import { request } from '../request';

const ambassadors = {
  // 获取大使列表
  getAmbassadorsList: (data) => request('/api/ambassadors', 'get', data),
  // 获取大使详情
  getAmbassadorsDetail: (data) => request(`/api/ambassadors/${data.name}`, 'get', data),
  /** Vooglam Studio 落地页报名 */
  submitStudioApplication: (data) =>
    request('/api/studio_submissions', 'post', data, {
      successMsg: false,
      errorMsg: true,
      successWithoutCode: true,
    }),
  /** 红人墙列表 */
  getWallList: (data) =>
    request('/api/subject/product_influencer_wall/lists', 'get', data, {
      errorMsg: false,
    }),
};
export default ambassadors;
